<template>
    <div
        v-if="normalizedLogos.length"
        :class="[
            rowClass,
            {
                'lg:items-center lg:justify-center': centred,
            },
        ]"
    >
        <template
            v-for="(accreditationLogo, accreditationLogoIndex) in normalizedLogos"
            :key="accreditationLogo.id || accreditationLogoIndex"
        >
            <NuxtLink
                v-if="accreditationLogo.link?.url"
                class="inline-flex w-auto"
                :to="accreditationLogo.link.url"
                :target="accreditationLogo.link.target"
            >
                <img
                    :src="accreditationLogo.logo.url"
                    :alt="accreditationLogo.logo.alt || accreditationLogo.link?.text || ''"
                    class="max-h-18 w-auto max-w-24 object-contain"
                >
            </NuxtLink>

            <img
                v-else
                :src="accreditationLogo.logo.url"
                :alt="accreditationLogo.logo.alt || ''"
                class="max-h-18 w-auto max-w-24 object-contain"
            >
        </template>
    </div>
</template>

<script setup>
    const props = defineProps({
        logos: {
            type: Array,
            default: () => [],
        },
        centred: {
            type: Boolean,
            default: false,
        },
        rowClass: {
            type: String,
            default: 'grid grid-cols-2 place-items-center lg:flex lg:flex-wrap gap-4 lg:gap-10',
        },
    })

    const firstOrSelf = (value) => {
        if (Array.isArray(value)) {
            return value[0]
        }

        return value
    }

    const normalizedLogos = computed(() => {
        const logos = Array.isArray(props.logos) ? props.logos : []

        return logos
            .map((accreditationLogo) => {
                const logo = firstOrSelf(accreditationLogo?.accreditationLogoItem_Logo)
                const link = firstOrSelf(accreditationLogo?.accreditationLogoItem_Link)

                return {
                    id: accreditationLogo?.id,
                    logo,
                    link,
                }
            })
            .filter((accreditationLogo) => accreditationLogo.logo?.url)
    })
</script>
